const background = {
	width: '100%',
	textAlign: 'start',
};

export { background };
